<template>
  <div class="cart-block cart-block-item clearfix">
        <div class="image">
          <img
              :src="cartItem.product.base_image.small"
              :class="{ 'image-placeholder': ! hasBaseImage(cartItem.product) }"
              alt="product image"
          >
        </div>
        <div class="title">
            <div><a :href="productUrl(cartItem.product)">{{ cartItem.product.name }}</a></div>
            <ul class="list-inline product-options">
                <li v-for="option in cartItem.options" :key="option.id">
                    <label>{{ option.name }}:</label> {{ optionValues(option) }}
                </li>
                <li v-for="variant in cartItem.variants" :key="variant.id">
                    <label>{{ variant.name }}:</label> {{ variantValues(variant) }}
                </li>
            </ul>
            <p class="delivery-time-line">{{ $trans('product::product.delivery_time') }}: <span v-if="cartItem.product.fast_delivery" v-html="$trans('cart::cart.delivery_time.7-dni')"></span> <span v-else v-html="$trans('cart::cart.delivery_time.'+cartItem.product.delivery_time)"></span> </p>
        </div>

        <div class="price">
          <div class="quantity product-quantity notranslate">
              {{ cartItem.qty }} x <span v-html="cartItem.unitPrice.inCurrentCurrency.formatted"></span>
          </div>
        </div>

        <button class="icon icon-cross icon-delete" :data-productId="cartItem.product.id" :data-productSku="cartItem.product.sku" :data-productPrice="cartItem.unitPrice.inCurrentCurrency.formatted" :data-productQty="cartItem.qty" @click="remove">
            <i class="icon icon-cross icon-delete"></i>
        </button>
    </div>
</template>

<script>
    import store from '../../store';
    import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';

    export default {
        mixins: [
            ProductHelpersMixin,
        ],

        props: ['cartItem'],

        methods: {
            optionValues(option) {
                let values = [];

                for (let value of option.values) {
                    values.push(value.label);
                }

                return values.join(', ');
            },

            variantValues(option) {
                let values = [];

                for (let value of option.values) {
                    values.push(value.label);
                }

                return values.join(', ');
            },

            remove() {
                store.removeCartItem(this.cartItem);

                $.ajax({
                    method: 'DELETE',
                    url: route('cart.items.destroy', { cartItemId: this.cartItem.id }),
                }).then((cart) => {
                    store.updateCart(cart);
                });
            },
        },
    };
</script>
